<template>
  <div>
    <span>时间：</span>
    <el-date-picker
      :editable="false"
      :clearable="false"
      class="yearInputBox"
      type="year"
      v-model="startTime"
      value-format="yyyy"
      size="mini"
      @change="changeDate"
      placeholder="选择年"
      :picker-options="startTimeDis"
    >
    </el-date-picker>
    -
    <el-date-picker
      class="yearInputBox date_box"
      type="year"
      :editable="false"
      :clearable="false"
      v-model="endTime"
      size="mini"
      value-format="yyyy"
      @change="changeDate"
      :picker-options="endTimeDis"
    >
      placeholder="选择年">
    </el-date-picker>
  </div>
</template>
<script>
export default {
  props: {
    startTimeDef: {
      default: "",
      type: String,
    },
    endTimeDef: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      startTime: this.startTimeDef,
      endTime: this.endTimeDef,
      startTimeDis: {
        disabledDate: (time) => {
          if (this.endTime) {
            return time.getTime() > new Date(this.endTime + "-01-01").getTime();
          } else {
            return false;
          }
        },
      },
      endTimeDis: {
        disabledDate: (time) => {
          if (this.startTime) {
            return (
              time.getTime() < new Date(this.startTime + "-01-01").getTime() ||
              time.getTime() > new Date().getTime()
            );
          } else {
            return time.getTime() > new Date().getTime();
          }
        },
      },
    };
  },
  created() {},
  watch: {},
  methods: {
    changeDate(value) {
      if (this.startTime && this.endTime) {
        this.$emit("getYearRange", [this.startTime, this.endTime]);
      }
    },
  },
};
</script>
<style>
@media (max-width: 1200px) {
  .yearInputBox {
    width: 69px !important;
  }
  .yearInputBox .el-input__inner {
    width: 69px !important;
  }
}
@media (min-width: 1200px) {
  .yearInputBox {
    width: 100px !important;
  }
  .yearInputBox .el-input__inner {
    width: 100px !important;
  }
}
</style>